module.exports = __webpack_public_path__ + "static/media/elo.f9735919.svg";